<template>
  <div>
    <div class="form-actions flex justify-between">
      <div class="flex vx-col-action">
        <vs-input icon-pack="feather" icon="icon-search" placeholder="Type here..." v-model="globalSearchTerm" class="is-label-placeholder searchBar-input" id="filter-text-box" v-on:input="onFilterTextBoxChanged()" />
        
        <span class="br-line mr-2 ml-2"></span>
      </div>

      <div class="float-right flex">
        <vs-chip transparent closable color="primary" class="chip-selected-rows" @click="deselectAllSelectedRows()">
          {{ this.gridApi ? this.gridApi.getSelectedNodes().length : 0 }} Rows Selected
        </vs-chip>
        
        <vx-tooltip :text="!flags['selectedAll'][currentPage - 1] ? 'Select All' : 'Deselect All'" position="top">
          <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" :icon="flags['selectedAll'][currentPage - 1] ? 'icon-check-square' : 'icon-square'" @click="toggleSelectAll()" :disabled="this.emptyList"></vs-button>
        </vx-tooltip>

        <span class="br-line-long mr-4 ml-4 h-60"></span>

        <vs-button v-if="isLocalApproveRejectRule" class="iconOnly promo-approve-icon" color="primary" type="flat" icon-pack="feather" icon="icon-check-circle" @click="approveCnicPromo()" :disabled="this.selectedRowCount == 0 || this.rejectedPromo || this.emptyList"></vs-button>
        <vs-button v-if="isLocalApproveRejectRule" class="iconOnly promo-reject-icon" color="danger" type="flat" icon-pack="feather" icon="icon-x-circle" @click="activePrompt=true" :disabled="this.selectedRowCount == 0 || this.emptyList || this.rejectedPromo"></vs-button>

        <span class="br-line-long mr-4 ml-4 h-60"></span>

        <vs-button v-if="!this.editReq && isLocalEditRule" class="iconOnly promo-edit-icon" color="success" type="flat" icon-pack="feather" icon="icon-edit" @click="editCnicPromo()" :disabled="this.selectedRowCount == 0 || this.emptyList || this.rejectedPromo"></vs-button>
        <vs-button class="iconOnly promo-reject-icon" color="dark" type="flat" icon-pack="feather" icon="icon-trash-2" @click="cnicPromoBulkDeleteConfirm()" :disabled="this.selectedRowCount == 0"></vs-button>


        <span class="br-line-long mr-4 ml-4 h-60"></span>

        <vx-tooltip text="Download list" position="top">
          <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-download" @click="downloadData()"></vs-button>
        </vx-tooltip>
        <vx-tooltip text="Reset Filters" position="top">
          <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-refresh-ccw" @click="refreshPageWithFilters()"></vs-button>
        </vx-tooltip>
      </div>
    </div>

    <div class="promoRequestGrid">
      <div class="scrollable-area">
        <div id="grid-loader" class="vx-card vs-con-loading__container">
          <ag-grid-vue
            id="autoHeightGrid"
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 mb-4 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :components="components"
            :rowData="tableData"
            rowSelection="multiple"
            :enableRangeSelection="true"
            :suppressCopyRowsToClipboard="true"
            :suppressDragLeaveHidesColumns="true"
            :animateRows="false"
            :floatingFilter="true"
            :pagination="false"
            :paginationPageSize="paginationPageSize"
            :suppressPaginationPanel="true"
            :suppressRowClickSelection="true"
            :rowClassRules="rowClassRules"
            :statusBar="statusBar"
            :sideBar="sideBar"
            :rowHeight="30"
            :headerHeight="30"
            :floatingFiltersHeight="35"
            :checkboxSelection="true"
            :domLayout="domLayout"
            :enableBrowserTooltips="true"
            @row-selected="onRowSelected"
            @pagination-changed="onPaginationChanged"
            @column-resized="onColumnResized">
          </ag-grid-vue>
        </div>
      </div>
    </div>
    
    <vs-prompt
      @cancel="resetComment"
      @accept="rejectCnicPromo"
      :is-valid="validComment"
      :title="rejectTitle"
      :active.sync="activePrompt"
      :acceptText="yesText"
      :cancelText="noText">
      <div class="vx-col w-full">
        <label class="vs-input--label">Comments</label>
        <vs-textarea class="mt-3 w-full" v-model="reject_comments" />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import "@/assets/scss/radix/extraComponents/agGridStyleOverride.scss";

import CellRendererStatus from "@/components/ag-grid-tables/actions/CellRendererStatus.vue";
import CellRendererAgreementList from "@/components/ag-grid-tables/actions/CellRendererAgreementList.vue";

export default {
  name: "CnicPromoRequestComponent",
  components: {
    AgGridVue,
    CellRendererStatus,
    CellRendererAgreementList,
  },
  props: {
    editReq: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedRowCount: "",
      rejectedPromo: false,
      activePrompt: false,
      reject_comments: "",
      autoGroupColumnDef: null,
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        suppressMovable: false,
        filterParams: {
          suppressAndOrCondition: true,
          newRowsAction: "keep",
        },
      },
      rowClassRules: null,
      statusBar: null,
      sideBar: null,
      columnDefs: null,
      domLayout: null,
      tableData: null,
      selectedPromos: [],
      emptyList: true,
      // Cell Renderer Components
      components: {
        CellRendererStatus,
      },
      // NOTE: ACTIONS:
      globalSearchTerm: "",
      flags: {
          selectedAll: [],
      },
    };
  },
  watch: {
    windowWidth(val) {
      // Toggle colummn movable
      this.toggleColumnMovable(val);
      // Toggle colummn pinning
      this.toggleColumnPinned(val);
    },
  },
  computed: {
    windowWidth: function () {
      return this.$store.state.windowWidth;
    },
    user_role() {
      return JSON.parse(localStorage.getItem("userDetails")).role;
    },
    user_id() {
      return JSON.parse(localStorage.getItem("userDetails")).id;
    },
    status() {
      return event.node;
    },
    paginationPageSize() {
      if (this.gridApi) {
        return this.gridApi.paginationGetPageSize();
      } else {
        return 15;
      }
    },
    totalPages() {
      if (this.gridApi) {
        return this.gridApi.paginationGetTotalPages();
      } else {
        return 0;
      }
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
    validComment() {
      return this.reject_comments.length > 0;
    },
    rejectTitle() {
      return "Reject Selected Promos?";
    },
    yesText() {
      return "Yes";
    },
    noText() {
      return "No";
    },
    isLocalApproveRejectRule() {
      return this.$acl.check('isSuperAdmin') || this.$acl.check('isChannelAdmin') || this.$acl.check('isBIAdmin');
    },
    isLocalEditRule() {
      return this.$acl.check('isSuperAdmin') || this.$acl.check('isChannelAdmin') || this.$acl.check('isBIAdmin') || this.$acl.check('isChannelUser');
    },
  },
  methods: {
    onPageSizeChanged(newPageSize) {
      var value = document.getElementById("page-size").value;
      this.gridApi.paginationSetPageSize(Number(value));
    },

    onPaginationChanged() {
      if (this.gridApi) {
        (this.totalRows = this.gridApi.paginationGetRowCount()),
          (this.currentPageSize = this.gridApi.paginationGetPageSize());
      }
    },
    onRowSelected(event) {
      var getStatus = this.gridApi
        .getSelectedNodes()
        .map((x) => x.data)
        .map((x) => x.status);
      getStatus.includes("rejected")
        ? (this.rejectedPromo = true)
        : (this.rejectedPromo = false);
      if (event.node.selected) {
        // Push to selectedPromos
        this.selectedRowCount = this.gridApi.getSelectedNodes().length;
      } else {
        // Remove from selectedPromos
        this.selectedRowCount = this.gridApi.getSelectedNodes().length;
      }
    },
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 0.8,
      });
    },
    hideLoadingInDiv() {
      this.$vs.loading.close("#div-with-loading > .con-vs-loading");
    },

    setAutoHeight() {
      this.gridApi.setDomLayout("autoHeight");
      // auto height will get the grid to fill the height of the contents,
      // so the grid div should have no height set, the height is dynamic.
      document.querySelector("#autoHeightGrid").style.height = "";
    },

    populateTableData() {
      let self = this;

      let url = this.editReq
        ? "/cnic-promos/edit/not-approved"
        : "/cnic-promos/not-approved";

      /* Get table data */
      this.$axiosSecure
        .get(url)
        .then((response) => {
          //Passing premium value as Yes or No
          for (var key in response.data) {
            if (response.data[key].premium == 0) {
              response.data[key].premium = "No";
            } else {
              response.data[key].premium = "Yes";
            }
          }

          this.tableData = response.data.filter(
            (x) => !(x["status"] == "scheduled" || x["status"] == "active" || x["status"] == "new approved" || x["status"] == "approved")
          );

          if (this.editReq) {
            this.formatEditReqData(this.tableData);
          }

          if (this.tableData.length > 0) {
            this.emptyList = false;
          }

          if (this.gridApi) {
            setTimeout(() => {
              this.initSelectedAllFlag();

              // NOTE: If logged in user is Erica, use name to apply filter, don't apply filter for any other logged in user
              if(this.isAMExclusionActive()) {
                var defaultFilter = {
                  'am.name': {
                    type: 'set',
                    values: [process.env.VUE_APP_AM_EXCLUSION],
                  },
                };
                this.gridApi.setFilterModel(defaultFilter);
              }
            }, 50);
          }
        })
        .catch((error) => {
          // Error notification
          self.$vs.notify({
            color: "danger",
            title: "Something went wrong",
            text: "Please contact the server admin",
          });

          console.log(error);

          // Clear Listing Count
          this.$store.dispatch("clearListingCount");
        })
        .finally(() => {
          this.$emit("newRequestApiSuccess");
        });
    },

    toggleColumnMovable(val) {
      if (val <= 576) {
        this.defaultColDef["suppressMovable"] = true;
      } else {
        this.defaultColDef["suppressMovable"] = false;
      }
    },
    toggleColumnPinned(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("domain", null);
      } else {
        this.gridOptions.columnApi.setColumnPinned("domain", "left");
      }
    },
    onColumnResized() {
      this.gridApi.resetRowHeights();
    },
    sizeColumnsToFit() {
      this.gridApi.sizeColumnsToFit();
    },
    disableQueue() {
      this.rowClassRules = {
        "ag-row-disabled": 'data && (data.status == "new approved" || data.status == "queued" || data.status == "active")',
        "ag-row-red": 'data && (data.status == "rejected")',
      };
    },
    gridDeselectAll() {
      this.gridApi.forEachNodeAfterFilter((node) => {
        if (
          node["rowIndex"] >=
            (this.currentPage - 1) *
              this.gridApi.paginationGetPageSize() &&
          node["rowIndex"] <
            this.currentPage * this.gridApi.paginationGetPageSize()
        ) {
          node.setSelected(false);
        }
      });
    },
    refreshPage() {
      this.initSelectedAllFlag();
      // Reset selection
      this.gridApi.deselectAll();
      // Reset sort
      this.gridApi.setSortModel(null);
      // Table Data AXIOS Call
      this.populateTableData();
    },
    refreshPageWithFilters() {
      this.initSelectedAllFlag();
      // Reset filters
      this.gridApi.setFilterModel(null);
      // Reset selection
      this.gridApi.deselectAll();
      // Reset sort
      this.gridApi.setSortModel(null);
      // Table Data AXIOS Call
      this.populateTableData();
    },
    gridSelectAll() {
      this.gridApi.forEachNodeAfterFilter((node) => {
        if (
          !(
            node.data.status == "new approved" ||
            node.data.status == "rejected" ||
            node.data.status == "error"
          )
        ) {
          if (this.selectAll) {
            // Unselect the node
            node.setSelected(false);
          } else {
            // Select the node
            node.setSelected(true);
            var selectedRowId = node.data.id;
          }
        }
      });
    },

    approveCnicPromo() {
      this.openLoadingInDiv();
      // console.log("selected", this.gridApi.getSelectedNodes());
      var selectedRowData = this.gridApi.getSelectedNodes().map((x) => x.data);
      var selectedRowId = selectedRowData.map((x) => x.id);

      let url = this.editReq
        ? "/cnic-promos/edit/approve"
        : "/cnic-promos/approve";

      this.$axiosSecure
        .post(url, {
          id: selectedRowId,
        })

        .then((response) => {
          // console.log("success", response);
          setTimeout(() => {
            this.refreshPage();
            //Hide loader
            this.hideLoadingInDiv();
            // Confimation notification
            this.$vs.dialog({
              color: "success",
              title: "Approved successfully",
              text: "Selected CNIC Promo(s) have been approved.",
              acceptText: "Close",
              accept: () => {
              },
            });
          }, 100);
        })
        .catch((error) => {
          console.log("error", error);
          this.hideLoadingInDiv();
          this.$vs.dialog({
            color: "danger",
            title: "Something went wrong",
            text: "Please contact the server admin",
            acceptText: "Close",
            accept: () => {},
          });
        });
    },

    rejectCnicPromo() {
      this.openLoadingInDiv();
      var selectedRowData = this.gridApi.getSelectedNodes().map((x) => x.data);
      var selectedRowId = selectedRowData.map((x) => x.id);

      let url = this.editReq
        ? "/cnic-promos/edit/reject"
        : "/cnic-promos-requests/reject";

      this.$axiosSecure
        .post(url, {
          rejected_by: this.user_id,
          id: selectedRowId,
          rejected_comments: this.reject_comments,
          status: "rejected",
        })

        .then((response) => {
          setTimeout(() => {
            this.refreshPage();
            this.resetComment();
            //Hide loader
            this.hideLoadingInDiv();
            // Confimation notification
            this.$vs.dialog({
              color: "danger",
              title: "Selected Promos Rejected",
              text: "Selected CNIC Promo(s) have been rejected.",
              acceptText: "Close",
              accept: () => {
              },
            });
          }, 100);
        })
        .catch((error) => {
          console.log("error", error);
          this.hideLoadingInDiv();
          this.$vs.dialog({
            color: "danger",
            title: "Something went wrong",
            text: "Please contact the server admin",
            acceptText: "Close",
            accept: () => {},
          });
        });
    },

    cnicPromoBulkDeleteConfirm() {
      // Open confirm popup
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: "Confirm",
        text: "Delete Selected Promo?",
        acceptText: "Yes",
        cancelText: "No",
        accept: () => {
          this.deleteCnicPromo();
        },
      });
    },

    deleteCnicPromo() {
      this.openLoadingInDiv();
      var selectedRowData = this.gridApi.getSelectedNodes().map((x) => x.data);
      var selectedRowId = selectedRowData.map((x) => x.id);

      let url = this.editReq
        ? "/cnic-promos/edit/delete"
        : "/cnic-promos-requests/delete";

      this.$axiosSecure
        .post(url, {
          id: selectedRowId,
        })

      .then((response) => {
        setTimeout(() => {
          this.refreshPage();
          //Hide loader
          this.hideLoadingInDiv();
          // Confimation notification
          this.$vs.dialog({
            color: "success",
            title: "Deleted successfully",
            text: "Selcted CNIC Promos have been deleted.",
            acceptText: "Close",
            accept: () => {},
          });
        }, 100);
      })
      .catch((error) => {
        console.log("error", error);
        this.hideLoadingInDiv();
        //Error msg
        this.$vs.dialog({
          color: "danger",
          title: "Something went wrong",
          text: "Please contact the server admin",
          acceptText: "Close",
          accept: () => {},
        });
      });
    },

    resetComment() {
      this.reject_comments = "";
      this.gridApi.deselectAll();
    },

    editCnicPromo() {
      var selectedRowData = this.gridApi.getSelectedNodes();
      this.$root.$emit("selectedGroupEditCNIC", selectedRowData, false, this.editReq);
    },

    formatEditReqData(data) {
      data.forEach((x) => {
        x.cnic_promo.id = x.id;
        x.cnic_promo.end_date = x.end_date;
        x.cnic_promo.end_time = x.end_time;
        x.cnic_promo.status = x.status;
        x.cnic_promo.comments = x.comments;
      });

      var tempData = data.map((x) => {
        return x.cnic_promo;
      });

      this.tableData = tempData;
    },
    openConfirm() {
      // Open confirm popup
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: "Confirm",
        text: "Approving all promos. Are you sure?",
        acceptText: "Approve",
        cancelText: "Go Back",
        accept: () => {
          this.approveCnicPromo();
        },
        cancel: () => {
          this.gridApi.deselectAll();
        },
      });
    },
    toggleSelectAll() {
      if (this.flags["selectedAll"][this.currentPage - 1]) {
        this.gridDeselectAll();
        this.flags["selectedAll"][this.currentPage - 1] = !this.flags["selectedAll"][this.currentPage - 1];
      } else {
        this.selectedRowCount = this.gridApi.getSelectedNodes().length;
        if (this.selectedRowCount < 30 && this.selectedRowCount + 15 <= 30) {
          this.gridSelectAll();
          this.flags["selectedAll"][this.currentPage - 1] =
            !this.flags["selectedAll"][this.currentPage - 1];
        } else {
          this.$vs.notify({
            time: 5000,
            color: "warning",
            title: "Warning",
            text: "You may select only upto 30 rows",
          });
        }
      }
    },
    initSelectedAllFlag() {
      if (this.tableData.length) {
        for (let i = 0; i < this.gridApi.paginationGetTotalPages(); i++) {
          this.flags["selectedAll"].push(false);
        }
      }
    },
    deselectAllSelectedRows() {
      this.gridApi.deselectAll();

      this.flags["selectedAll"].fill(false);
    },
  },
  beforeMount() {
    this.disableQueue();

    // Table Data AXIOS Call
    this.populateTableData();

    // Reset movable columns on mobile
    this.toggleColumnMovable(this.windowWidth);

    (this.columnDefs = [
      {
        headerName: "Promo Name",
        field: "promo_name",
        filter: "agSetColumnFilter",
        checkboxSelection: true,
        minWidth: 280,
        width: 250,
        pinned: "left",
        tooltipField: "promo_name"
        // cellClass: "cellCustomWrap",
      },
      {
        headerName: "Registrar Name",
        field: "new_registrar.unique_registrar.name",
        filter: "agSetColumnFilter",
        minWidth: 150,
        width: 250,
        pinned: "left",
        tooltipField: "new_registrar.unique_registrar.name"
        // cellClass: "cellCustomWrap",
      },
      {
        headerName: "Type",
        field: "type_of_reg",
        filter: "agSetColumnFilter",
        minWidth: 150,
        pinned: "left",
      },
      {
        headerName: "TLD",
        field: "tld.tld_name",
        filter: "agSetColumnFilter",
        minWidth: 100,
        width: 150,
        pinned: "left",
      },
      {
        headerName: "CNIC ID",
        field: "new_registrar.cnic_id",
        filter: "agSetColumnFilter",
        minWidth: 150,
        width: 250,
      },
      {
        headerName: "Status",
        field: "status",
        filter: "agSetColumnFilter",
        cellRendererFramework: "CellRendererStatus",
        minWidth: 130,
      },
      {
        headerName: "AM",
        field: "am.name",
        filter: "agSetColumnFilter",
        minWidth: 150,
        width: 250,
        suppressFilter: this.isAMExclusionActive() ? true : false
      },
      {
        headerName: "Amount",
        field: "effective_price_amt",
        filter: "agTextColumnFilter",
        minWidth: 130,
      },
      {
        headerName: "Percentage",
        field: "effective_price_per",
        filter: "agTextColumnFilter",
        minWidth: 130,
      },
      {
        headerName: "Start Date",
        field: "start_date",
        filter: "agDateColumnFilter",
        minWidth: 175,
        filterParams: {
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            let dateAsString = cellValue;
            if (dateAsString == null) return -1;
            let dateParts = dateAsString.split("-");
            let cellDate = new Date(
              Number(dateParts[0]),
              Number(dateParts[1]) - 1,
              Number(dateParts[2])
            );
            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
          },
          browserDatePicker: true,
        },
      },
      {
        headerName: "End Date",
        field: "end_date",
        filter: "agDateColumnFilter",
        minWidth: 175,
        filterParams: {
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            let dateAsString = cellValue;
            if (dateAsString == null) return -1;
            let dateParts = dateAsString.split("-");
            let cellDate = new Date(
              Number(dateParts[0]),
              Number(dateParts[1]) - 1,
              Number(dateParts[2])
            );
            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
          },
          browserDatePicker: true,
        },
      },
      
      {
        headerName: "Registrar ID",
        field: "registrar.cnic_id",
        filter: "agTextColumnFilter",
        minWidth: 150,
        hide: true,
      },
      {
        headerName: "Premiums",
        field: "premium",
        filter: "agSetColumnFilter",
        minWidth: 150,
        hide: true,
      },
      {
        headerName: "Start Time",
        field: "start_time",
        filter: "agTextColumnFilter",
        minWidth: 150,
        hide: true,
      },
      {
        headerName: "End Time",
        field: "end_time",
        filter: "agTextColumnFilter",
        minWidth: 150,
        hide: true,
      },

      {
        headerName: "Created By",
        field: "user.name",
        filter: "agSetColumnFilter",
        minWidth: 150,
        hide: true,
      },
      {
        headerName: "Agreements",
        field: "dropbox_detail",
        filter: "agSetColumnFilter",
        cellRendererFramework: "CellRendererAgreementList",
        cellRendererParams: {
          source: "cnic",
          editPendingReq: this.editReq
        },
        minWidth: 130,
      },
      {
        headerName: "Comments",
        field: "comments",
        filter: "agTextColumnFilter",
        minWidth: 150,
        width: 100,
        tooltipField: "comments"
        // cellClass: "cellCustomWrap",
      },
    ]),
      // Set Grid sidebar
      (this.sideBar = {
        toolPanels: [
          {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
            toolPanelParams: {
              suppressRowGroups: true,
              suppressValues: true,
              suppressPivots: true,
              suppressPivotMode: true,
              suppressSideButtons: true,
              suppressColumnSelectAll: true,
              suppressColumnExpandAll: true,
            },
          },
        ],
      });
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    //agigrid loader
    this.gridApi.showLoadingOverlay();

    // Resize to fit columns
    this.sizeColumnsToFit();

    //set Auto height
    this.setAutoHeight();

    // Reset pinned columns on mobile
    this.toggleColumnPinned(this.windowWidth);

    // this.populateTableData();

    // Page Refresh Event
    // this.$root.$on("refreshPage", () => {
    //   // Reset filters
    //   this.gridApi.setFilterModel(null);
    //   // Reset selection
    //   this.gridApi.deselectAll();
    //   // Reset sort
    //   this.gridApi.setSortModel(null);
    //   // Table Data AXIOS Call
    //   this.populateTableData();
    // });

    // Page Download Event
    this.$root.$on("downloadPage", () => {
      // AgGrid CSV Export
      this.gridApi.exportDataAsCsv();
    });

    // this.$root.$on("editPromoRequest", (rowData) => {
    //   // console.log(rowData.node.parent);
    //   // this.editPromoRequestPopup= true;
    //   this.formData['editRowData']= rowData.node.parent;
    // });

    // this.$root.$on("deletePromoRequest", (rowData) => {
    //   //console.log(rowData.node.parent);
    //   this.openDeletePromoConfirm(rowData.node.parent);
    // });

    this.$root.$on("tableRefresh", () => {
      // console.log('refresh');
      this.refreshPage();
    });
  },
  destroyed() {
    // Clear Listing Count
    this.$store.dispatch("clearListingCount");

    // Unbind Button Event Listeners
    this.$root.$off("tableRefresh");
  },
};
</script>

<style lang="scss">

.ag-selection-checkbox {
  display: flex;
  align-items: center;
  height: 36px;
}

.ag-row-disabled,
.ag-checkbox-disabled .ag-group-checkbox {
  pointer-events: none;
}

.ag-row-disabled .ag-group-checkbox,
.ag-checkbox-disabled .ag-group-checkbox {
  opacity: 0.3;
}

.ag-row-level-1 .ag-group-value,
.text-capitalize input {
  text-transform: capitalize;
}

//Hide grouping arrow
.ag-group-expanded,
.ag-group-contracted {
  display: none !important;
}

.ag-group-checkbox {
  margin-left: 0 !important;
}

.text-capitalize {
  text-transform: capitalize;
}

.vs-tabs--content {
  padding: 23px 0px !important;
}
</style>
